import React from "react";
import styled from "styled-components";

function Box({
  children,
  shadow,
  animation = true,
  borderRadius = true,
  ...rest
}) {
  return (
    <Container
      {...rest}
      className={`${shadow ? "shadow" : ""} ${
        animation ? "" : "animation-off"
      } ${borderRadius ? "border-radius" : ""}`}
    >
      {children}
    </Container>
  );
}

export default Box;

const Container = styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  position: relative;
  background-color: #fff;
  transition: all 0.3s;
  background-size: cover;
  background-position: center;
  &.border-radius {
    border-radius: 16px;
  }
  &.animation-off {
    &:hover {
      transform: none;
    }
  }
  &:hover {
    transform: translateY(-5px);
  }
  &.shadow {
    box-shadow: 1px 1px 5px 0 rgba(1, 1, 1, 0.05);
    &:hover {
      box-shadow: 0px 2px 4px rgba(46, 41, 51, 0.08),
        0px 5px 10px rgba(71, 63, 79, 0.16);
    }
  }
`;
